var SHARP_NN = {
	name: "SHARP NN",
	defaultCommandIndex: 1,
	commands: [
		{
			mode: "AC_MODE_OFF",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_NULL",
			command: [139,0,5,242,2,169,1,214,35,39,17,5,3,8,6,243,2,23,78,247,2,0,0,79,252,255,255,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,250,2,166,1,1,3,22,6,8,36,49,17,255,2,20,78,255,2,0,0,46,255,255,239,219,177,255,251,255,251,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,229,35,28,17,243,2,174,1,3,3,14,6,238,2,13,78,240,2,0,0,149,42,165,85,85,85,42,169,74,148,85,85,85,82,170,170,170,169,40,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,172,1,4,3,7,6,195,35,41,17,228,2,25,78,245,2,0,0,46,253,255,247,237,216,255,253,255,253,88,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,170,1,0,3,18,6,194,35,51,17,230,2,19,78,229,2,0,0,46,250,255,251,246,236,127,254,255,255,208,128],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,175,1,190,35,47,17,253,2,22,6,238,2,23,78,229,2,0,0,78,127,63,252,252,206,99,255,243,255,249,200,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,176,1,188,35,54,17,246,2,24,6,235,2,21,78,229,2,0,0,78,124,207,255,63,51,152,255,252,255,255,50,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,167,1,0,3,11,6,231,35,41,17,229,2,20,78,234,2,0,0,46,253,127,251,246,236,127,254,255,254,180,32],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,232,2,179,1,183,35,53,17,249,2,29,6,234,2,25,78,230,2,0,0,78,124,147,255,207,204,230,63,255,63,255,228,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,238,2,180,1,209,35,46,17,251,2,23,6,240,2,15,78,229,2,0,0,78,127,159,252,252,206,99,255,243,255,249,146,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,230,2,181,1,182,35,53,17,244,2,35,6,228,2,21,78,229,2,0,0,78,124,231,255,63,51,152,255,252,255,255,36,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,172,1,239,35,49,17,250,2,22,6,229,2,8,78,231,2,0,0,78,126,103,255,63,51,152,255,252,255,254,73,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,235,2,182,1,181,35,19,17,17,3,26,6,246,2,10,78,245,2,0,0,78,124,153,255,207,204,230,63,255,63,255,248,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,238,2,174,1,211,35,52,17,253,2,21,6,229,2,22,78,248,2,0,0,78,127,39,255,63,51,152,255,252,255,254,120,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,238,2,180,1,216,35,51,17,247,2,29,6,242,2,21,78,245,2,0,0,78,124,201,255,207,204,230,63,255,63,255,206,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,234,2,182,1,1,3,25,6,184,35,35,17,244,2,15,78,240,2,0,0,46,253,95,253,251,118,63,255,127,255,92,32],
		},
		///////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [139,0,5,228,2,184,1,183,35,53,17,246,2,39,6,253,2,18,78,252,2,0,0,78,79,255,252,252,206,99,255,243,255,249,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [139,0,5,236,2,174,1,216,35,39,17,4,3,25,6,229,2,16,78,230,2,0,0,78,79,63,255,63,51,152,255,252,255,255,38,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [139,0,5,244,2,164,1,238,35,32,17,3,3,15,6,239,2,252,77,245,2,0,0,78,79,159,255,63,51,152,255,252,255,254,73,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,165,1,205,35,29,17,12,3,11,6,231,2,10,78,231,2,0,0,78,79,39,255,207,204,230,63,255,63,255,242,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [139,0,5,248,2,162,1,237,35,35,17,6,3,4,6,1,3,16,78,245,2,0,0,78,79,207,255,63,51,152,255,252,255,254,114,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,166,1,201,35,44,17,0,3,20,6,229,2,19,78,231,2,0,0,78,79,51,255,207,204,230,63,255,63,255,204,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [139,0,5,246,2,165,1,211,35,30,17,9,3,4,6,237,2,22,78,239,2,0,0,78,79,147,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [139,0,5,247,2,175,1,198,35,37,17,255,2,13,6,247,2,12,78,246,2,0,0,78,79,36,255,243,243,57,143,255,207,255,249,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [139,0,5,247,2,165,1,229,35,37,17,2,3,3,6,253,2,7,78,241,2,0,0,78,79,231,255,63,51,152,255,252,255,254,100,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [139,0,5,247,2,166,1,237,35,30,17,10,3,3,6,255,2,11,78,240,2,0,0,78,79,57,255,207,204,230,63,255,63,255,201,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [139,0,5,244,2,163,1,238,35,29,17,6,3,10,6,250,2,9,78,233,2,0,0,78,79,153,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [139,0,5,245,2,163,1,211,35,33,17,8,3,10,6,244,2,11,78,4,3,0,0,78,79,38,127,243,243,57,143,255,207,255,254,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [139,0,5,248,2,164,1,213,35,32,17,9,3,3,6,255,2,0,78,0,3,0,0,78,79,201,255,207,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [139,0,5,249,2,175,1,195,35,70,17,247,2,13,6,252,2,10,78,6,3,0,0,78,79,50,127,243,243,57,143,255,207,255,243,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [139,0,5,244,2,171,1,254,2,11,6,202,35,43,17,255,2,10,78,5,3,0,0,46,190,175,254,253,187,31,255,191,255,174,16],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [139,0,5,235,2,180,1,184,35,51,17,247,2,23,6,243,2,15,78,247,2,0,0,78,103,255,252,252,206,99,255,243,255,249,152,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [139,0,5,242,2,165,1,2,3,6,6,222,35,42,17,238,2,12,78,241,2,0,0,46,221,255,251,246,236,127,254,255,255,88,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [139,0,5,240,2,169,1,196,35,49,17,255,2,20,6,229,2,9,78,240,2,0,0,78,103,159,255,63,51,152,255,252,255,254,73,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [139,0,5,232,2,180,1,213,35,51,17,250,2,31,6,249,2,17,78,230,2,0,0,78,103,39,255,207,204,230,63,255,63,255,242,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [139,0,5,241,2,176,1,211,35,49,17,255,2,13,6,230,2,7,78,230,2,0,0,78,103,207,255,63,51,152,255,252,255,254,114,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [139,0,5,238,2,174,1,191,35,36,17,1,3,27,6,230,2,16,78,228,2,0,0,78,103,51,255,207,204,230,63,255,63,255,204,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [139,0,5,233,2,166,1,193,35,54,17,245,2,31,6,255,2,14,78,230,2,0,0,78,103,147,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [139,0,5,231,2,182,1,193,35,62,17,241,2,34,6,241,2,11,78,229,2,0,0,78,103,36,255,243,243,57,143,255,207,255,249,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [139,0,5,244,2,165,1,204,35,34,17,4,3,3,6,231,2,10,78,232,2,0,0,78,103,231,255,63,51,152,255,252,255,254,100,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [139,0,5,235,2,181,1,174,35,58,17,243,2,27,6,253,2,14,78,228,2,0,0,78,103,57,255,207,204,230,63,255,63,255,201,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [139,0,5,240,2,171,1,194,35,55,17,248,2,18,6,229,2,26,78,230,2,0,0,78,103,153,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [139,0,5,229,2,183,1,219,35,46,17,253,2,33,6,246,2,19,78,248,2,0,0,78,103,38,127,243,243,57,143,255,207,255,254,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [139,0,5,229,2,155,1,181,35,52,17,246,2,31,6,245,2,8,78,0,3,0,0,78,103,201,255,207,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [139,0,5,239,2,169,1,196,35,33,17,8,3,12,6,229,2,15,78,244,2,0,0,78,103,50,127,243,243,57,143,255,207,255,243,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [139,0,5,238,2,171,1,191,35,43,17,2,3,22,6,228,2,19,78,244,2,0,0,78,103,146,127,243,243,57,143,255,207,255,228,225],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,248,2,162,1,204,35,30,17,7,3,3,6,253,2,10,78,0,3,0,0,78,73,255,255,63,51,152,255,252,255,254,102,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,246,2,171,1,214,35,20,17,11,3,4,6,3,3,253,77,8,3,0,0,78,73,207,255,207,204,230,63,255,63,255,201,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,251,2,162,1,213,35,22,17,14,3,2,6,252,2,6,78,4,3,0,0,78,73,231,255,207,204,230,63,255,63,255,146,97],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,246,2,163,1,1,36,39,17,253,2,5,6,250,2,15,78,249,2,0,0,78,73,201,255,243,243,57,143,255,207,255,252,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,238,2,176,1,190,35,56,17,245,2,25,6,229,2,10,78,229,2,0,0,78,73,243,255,207,204,230,63,255,63,255,156,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,238,2,180,1,186,35,43,17,253,2,21,6,240,2,22,78,241,2,0,0,78,73,204,255,243,243,57,143,255,207,255,243,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,240,2,174,1,193,35,45,17,254,2,12,6,229,2,17,78,231,2,0,0,78,73,228,255,243,243,57,143,255,207,255,228,200,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,227,2,183,1,212,35,50,17,244,2,37,6,0,3,245,77,229,2,0,0,78,73,201,63,252,252,206,99,255,243,255,254,72,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,240,2,171,1,221,35,43,17,250,2,21,6,230,2,13,78,229,2,0,0,78,73,249,255,207,204,230,63,255,63,255,153,33],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,169,1,223,35,25,17,10,3,17,6,229,2,9,78,229,2,0,0,78,73,206,127,243,243,57,143,255,207,255,242,72,64],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,239,2,178,1,191,35,46,17,251,2,18,6,229,2,25,78,230,2,0,0,78,73,230,127,243,243,57,143,255,207,255,228,146,16],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,241,2,175,1,196,35,35,17,6,3,19,6,227,2,18,78,250,2,0,0,78,73,201,159,252,252,206,99,255,243,255,255,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,239,2,168,1,203,35,42,17,254,2,14,6,230,2,15,78,243,2,0,0,78,73,242,127,243,243,57,143,255,207,255,231,132],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,237,2,183,1,189,35,44,17,253,2,20,6,229,2,14,78,246,2,0,0,78,73,204,159,252,252,206,99,255,243,255,252,225],
		},
		{
			mode: "AC_MODE_COOL",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,238,2,177,1,189,35,55,17,243,2,26,6,237,2,22,78,245,2,0,0,78,73,228,159,252,252,206,99,255,243,255,249,56,64],
		},
		////////////////////////HEAT/////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,211,35,29,17,248,2,161,1,0,3,21,6,254,2,0,78,241,2,0,0,169,42,170,170,170,170,85,82,149,40,170,170,170,165,85,85,85,85,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,251,2,161,1,205,35,28,17,254,2,22,6,9,3,5,78,241,2,0,0,114,124,255,252,252,206,99,255,243,255,249,200,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,247,2,162,1,207,35,38,17,1,3,23,6,238,2,0,78,237,2,0,0,114,126,127,252,252,206,99,255,243,255,252,200,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,172,1,219,35,37,17,239,2,30,6,229,2,19,78,227,2,0,0,114,124,159,255,63,51,152,255,252,255,254,76,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,248,2,164,1,225,35,26,17,1,3,21,6,255,2,5,78,234,2,0,0,114,127,63,252,252,206,99,255,243,255,254,72,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,248,2,168,1,220,35,11,17,245,2,32,6,229,2,12,78,231,2,0,0,114,124,207,255,63,51,152,255,252,255,254,100,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,251,2,165,1,233,35,22,17,2,3,16,6,6,3,252,77,245,2,0,0,114,126,79,255,63,51,152,255,252,255,255,36,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,251,2,161,1,235,35,30,17,250,2,16,6,4,3,8,78,242,2,0,0,114,124,147,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,239,2,178,1,175,35,53,17,226,2,14,6,254,2,7,78,5,3,0,0,114,127,159,252,252,206,99,255,243,255,255,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,247,2,165,1,207,35,22,17,1,3,20,6,251,2,5,78,249,2,0,0,114,124,231,255,63,51,152,255,252,255,254,120,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,250,2,162,1,209,35,27,17,8,3,14,6,4,3,4,78,11,3,0,0,114,126,103,255,63,51,152,255,252,255,255,56,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,248,2,163,1,234,35,32,17,245,2,19,6,253,2,255,77,0,3,0,0,114,124,153,255,207,204,230,63,255,63,255,147,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,248,2,163,1,206,35,21,17,252,2,20,6,1,3,1,78,254,2,0,0,114,127,39,255,63,51,152,255,252,255,255,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,230,35,29,17,247,2,162,1,250,2,16,6,250,2,2,78,247,2,0,0,169,42,165,37,85,85,74,170,82,165,21,85,85,84,170,170,170,169,74,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,245,2,165,1,205,35,32,17,251,2,20,6,238,2,7,78,247,2,0,0,114,126,73,255,207,204,230,63,255,63,255,201,132],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [139,0,5,242,2,172,1,222,35,43,17,246,2,32,6,227,2,5,78,230,2,0,0,114,79,255,252,252,206,99,255,243,255,255,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [139,0,5,252,2,162,1,213,35,21,17,1,3,13,6,252,2,255,77,241,2,0,0,114,79,63,255,63,51,152,255,252,255,254,114,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [139,0,5,248,2,163,1,235,35,27,17,1,3,20,6,251,2,3,78,241,2,0,0,114,79,159,255,63,51,152,255,252,255,255,50,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [139,0,5,254,2,161,1,239,35,22,17,2,3,16,6,1,3,245,77,243,2,0,0,114,79,39,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [139,0,5,254,2,164,1,216,35,19,17,7,3,15,6,0,3,249,77,242,2,0,0,114,79,207,255,63,51,152,255,252,255,255,146,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [139,0,5,245,2,165,1,206,35,35,17,250,2,20,6,238,2,8,78,237,2,0,0,114,79,51,255,207,204,230,63,255,63,255,153,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [139,0,5,252,2,160,1,209,35,22,17,249,2,18,6,9,3,253,77,241,2,0,0,114,79,147,255,207,204,230,63,255,63,255,201,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [139,0,5,254,2,164,1,245,35,27,17,3,3,17,6,6,3,8,78,245,2,0,0,114,79,36,255,243,243,57,143,255,207,255,228,146,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [139,0,5,250,2,166,1,207,35,18,17,255,2,14,6,252,2,13,78,11,3,0,0,114,79,231,255,63,51,152,255,252,255,255,225],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [139,0,5,254,2,162,1,203,35,26,17,253,2,16,6,10,3,251,77,252,2,0,0,114,79,57,255,207,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,172,1,195,35,38,17,250,2,24,6,230,2,13,78,245,2,0,0,114,79,153,255,207,204,230,63,255,63,255,206,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [139,0,5,247,2,172,1,212,35,9,17,246,2,28,6,231,2,20,78,245,2,0,0,114,79,38,127,243,243,57,143,255,207,255,228,225],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [139,0,5,253,2,165,1,231,35,27,17,8,3,9,6,2,3,1,78,10,3,0,0,114,79,201,255,207,204,230,63,255,63,255,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [139,0,5,244,2,164,1,229,35,28,17,249,2,23,6,236,2,9,78,250,2,0,0,114,79,50,127,243,243,57,143,255,207,255,230,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [139,0,5,239,35,18,17,249,2,166,1,4,3,15,6,236,2,13,78,7,3,0,0,169,37,84,146,170,170,165,85,41,82,138,170,170,170,85,85,85,85,37,8],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [139,0,5,248,2,165,1,204,35,24,17,251,2,27,6,241,2,14,78,236,2,0,0,114,103,255,252,252,206,99,255,243,255,255,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [139,0,5,253,2,165,1,207,35,45,17,4,3,15,6,9,3,2,78,246,2,0,0,114,103,63,255,63,51,152,255,252,255,254,114,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [139,0,5,248,2,167,1,209,35,25,17,252,2,23,6,246,2,6,78,235,2,0,0,114,103,159,255,63,51,152,255,252,255,255,50,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [139,0,5,250,2,162,1,216,35,30,17,250,2,16,6,0,3,5,78,243,2,0,0,114,103,39,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [139,0,5,10,3,161,1,214,35,235,16,0,3,18,6,255,2,3,78,241,2,0,0,114,103,207,255,63,51,152,255,252,255,255,146,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [139,0,5,2,3,166,1,207,35,253,16,4,3,15,6,10,3,254,77,245,2,0,0,114,103,51,255,207,204,230,63,255,63,255,153,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [139,0,5,242,2,169,1,209,35,34,17,247,2,24,6,230,2,6,78,228,2,0,0,114,103,147,255,207,204,230,63,255,63,255,201,33],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [139,0,5,247,2,166,1,228,35,30,17,242,2,20,6,254,2,6,78,240,2,0,0,114,103,36,255,243,243,57,143,255,207,255,228,146,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [139,0,5,251,2,162,1,210,35,28,17,255,2,17,6,9,3,5,78,5,3,0,0,114,103,231,255,63,51,152,255,252,255,255,225],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [139,0,5,250,2,164,1,235,35,27,17,5,3,15,6,4,3,3,78,0,3,0,0,114,103,57,255,207,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [139,0,5,249,2,167,1,206,35,25,17,0,3,20,6,255,2,7,78,0,3,0,0,114,103,153,255,207,204,230,63,255,63,255,206,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [139,0,5,254,2,160,1,228,35,1,17,3,3,14,6,1,3,4,78,6,3,0,0,114,103,38,127,243,243,57,143,255,207,255,228,225],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [139,0,5,242,2,170,1,223,35,38,17,245,2,32,6,229,2,14,78,241,2,0,0,114,103,201,255,207,204,230,63,255,63,255,230,16],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [139,0,5,239,2,171,1,221,35,55,17,244,2,34,6,229,2,22,78,245,2,0,0,114,103,50,127,243,243,57,143,255,207,255,230,97],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [139,0,5,247,2,161,1,229,35,23,17,252,2,21,6,1,3,2,78,254,2,0,0,114,103,146,127,243,243,57,143,255,207,255,242,97],
		},
		/////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,241,2,174,1,185,35,46,17,244,2,33,6,230,2,7,78,230,2,0,0,114,73,255,255,63,51,152,255,252,255,255,200,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,168,1,199,35,48,17,244,2,30,6,230,2,15,78,230,2,0,0,114,73,207,255,207,204,230,63,255,63,255,156,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,241,2,185,1,179,35,49,17,236,2,38,6,253,2,5,78,232,2,0,0,114,73,231,255,207,204,230,63,255,63,255,204,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,172,1,199,35,34,17,243,2,31,6,229,2,13,78,226,2,0,0,114,73,201,255,243,243,57,143,255,207,255,228,200,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,241,2,183,1,187,35,51,17,240,2,35,6,243,2,11,78,241,2,0,0,114,73,243,255,207,204,230,63,255,63,255,228,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,241,2,169,1,227,35,44,17,245,2,29,6,230,2,11,78,229,2,0,0,114,73,204,255,243,243,57,143,255,207,255,230,72,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,248,2,163,1,216,35,34,17,251,2,19,6,254,2,251,77,241,2,0,0,114,73,228,255,243,243,57,143,255,207,255,242,72,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,243,2,168,1,201,35,39,17,243,2,24,6,230,2,17,78,230,2,0,0,114,73,201,63,252,252,206,99,255,243,255,249,36,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,245,2,164,1,221,35,13,17,242,2,27,6,230,2,5,78,248,2,0,0,114,73,249,255,207,204,230,63,255,63,255,248,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,251,2,166,1,210,35,1,17,251,2,21,6,237,2,7,78,2,3,0,0,114,73,206,127,243,243,57,143,255,207,255,231,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,170,1,195,35,44,17,246,2,30,6,229,2,0,78,250,2,0,0,114,73,230,127,243,243,57,143,255,207,255,243,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,240,2,177,1,195,35,43,17,243,2,31,6,228,2,13,78,244,2,0,0,114,73,201,159,252,252,206,99,255,243,255,249,56,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,178,1,217,35,48,17,227,2,9,6,0,3,11,78,5,3,0,0,114,73,242,127,243,243,57,143,255,207,255,249,132],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,244,2,167,1,219,35,38,17,247,2,22,6,235,2,2,78,1,3,0,0,114,73,204,159,252,252,206,99,255,243,255,249,152,64],
		},
		{
			mode: "AC_MODE_HEAT",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,250,2,162,1,202,35,32,17,251,2,17,6,253,2,3,78,254,2,0,0,114,73,228,159,252,252,206,99,255,243,255,252,152,64],
		},
		///////////////////////////AUTO//////////////////////////////
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,254,2,164,1,211,35,19,17,8,3,15,6,1,3,3,78,247,2,0,0,121,243,159,252,252,206,99,255,243,255,249,146,16],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_LOW",
			command: [139,0,5,247,2,164,1,227,35,6,17,252,2,23,6,230,2,13,78,233,2,0,0,121,60,231,255,63,51,152,255,252,255,254,100,132],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_MID",
			command: [139,0,5,249,2,165,1,239,35,21,17,254,2,16,6,9,3,1,78,245,2,0,0,121,156,231,255,63,51,152,255,252,255,254,100,132],
		},
		{
			mode: "AC_MODE_AUTO",
			temperature: "AC_TEMP_NULL",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,240,2,174,1,197,35,37,17,247,2,30,6,229,2,18,78,229,2,0,0,121,39,57,255,207,204,230,63,255,63,255,153,33],
		},
		/////////////////////////////DRY/////////////////////////////////
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [139,0,5,242,2,178,1,245,2,36,6,172,35,92,17,227,2,24,78,248,2,0,0,54,191,255,247,237,216,255,253,255,254,176,128],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [139,0,5,243,2,173,1,188,35,89,17,245,2,36,6,247,2,28,78,242,2,0,0,102,79,63,255,63,51,152,255,252,255,254,73,132],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [139,0,5,243,2,173,1,228,35,50,17,244,2,26,6,250,2,25,78,231,2,0,0,102,79,159,255,63,51,152,255,252,255,255,200,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [139,0,5,242,2,173,1,225,35,43,17,239,2,25,6,243,2,32,78,232,2,0,0,102,79,39,255,207,204,230,63,255,63,255,156,132],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [139,0,5,242,2,173,1,226,35,51,17,245,2,36,6,240,2,39,78,230,2,0,0,102,79,207,255,63,51,152,255,252,255,255,50,16],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,173,1,225,35,53,17,242,2,34,6,229,2,30,78,231,2,0,0,102,79,51,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [139,0,5,240,2,170,1,209,35,64,17,246,2,25,6,235,2,17,78,231,2,0,0,102,79,147,255,207,204,230,63,255,63,255,228,132],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [139,0,5,243,2,169,1,204,35,45,17,242,2,23,6,230,2,29,78,231,2,0,0,102,79,36,255,243,243,57,143,255,207,255,230,72,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [139,0,5,243,2,180,1,198,35,39,17,239,2,38,6,241,2,41,78,229,2,0,0,102,79,231,255,63,51,152,255,252,255,255,36,132],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [139,0,5,245,2,166,1,241,35,34,17,249,2,29,6,232,2,35,78,234,2,0,0,102,79,57,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,185,1,230,35,47,17,236,2,36,6,245,2,34,78,243,2,0,0,102,79,153,255,207,204,230,63,255,63,255,248,64],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,175,1,200,35,56,17,245,2,36,6,230,2,33,78,241,2,0,0,102,79,38,127,243,243,57,143,255,207,255,231,132],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [139,0,5,244,2,173,1,227,35,56,17,244,2,35,6,230,2,39,78,241,2,0,0,102,79,201,255,207,204,230,63,255,63,255,206,16],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,183,1,226,35,57,17,243,2,36,6,235,2,32,78,243,2,0,0,102,79,50,127,243,243,57,143,255,207,255,228,225],
		},
		{
			mode: "AC_MODE_DRY",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [139,0,5,243,2,167,1,208,35,39,17,249,2,20,6,230,2,35,78,240,2,0,0,102,79,146,127,243,243,57,143,255,207,255,249,132],
		},
		/////////////////////////FAN//////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,243,2,166,1,208,35,47,17,1,3,22,6,243,2,33,78,243,2,0,0,73,159,255,252,252,206,99,255,243,255,249,38,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,170,1,4,3,25,6,203,35,69,17,231,2,31,78,231,2,0,0,43,125,255,251,246,236,127,254,255,255,208,128],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,230,2,180,1,195,35,46,17,248,2,30,6,239,2,29,78,241,2,0,0,73,159,159,255,63,51,152,255,252,255,254,114,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,242,2,168,1,7,3,23,6,209,35,39,17,230,2,32,78,231,2,0,0,43,125,127,253,251,118,63,255,127,255,180,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,170,1,7,3,15,6,227,35,36,17,245,2,23,78,231,2,0,0,43,127,127,251,246,236,127,254,255,254,180,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,168,1,215,35,43,17,3,3,24,6,245,2,32,78,229,2,0,0,73,159,51,255,207,204,230,63,255,63,255,228,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,166,1,10,3,17,6,209,35,33,17,236,2,20,78,237,2,0,0,43,126,191,253,251,118,63,255,127,255,106,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,240,2,174,1,0,3,22,6,223,35,45,17,230,2,30,78,229,2,0,0,43,125,95,254,253,187,31,255,191,255,213,8],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,165,1,226,35,42,17,2,3,10,6,239,2,20,78,231,2,0,0,73,159,231,255,63,51,152,255,252,255,254,73,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,233,2,173,1,227,35,53,17,249,2,33,6,250,2,33,78,249,2,0,0,73,159,57,255,207,204,230,63,255,63,255,248,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,169,1,225,35,49,17,252,2,23,6,231,2,27,78,246,2,0,0,73,159,153,255,207,204,230,63,255,63,255,158,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,229,2,183,1,186,35,49,17,246,2,40,6,252,2,28,78,253,2,0,0,73,159,38,127,243,243,57,143,255,207,255,243,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,238,2,170,1,205,35,50,17,254,2,24,6,231,2,28,78,249,2,0,0,73,159,201,255,207,204,230,63,255,63,255,147,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,238,2,170,1,187,35,44,17,2,3,12,6,230,2,24,78,244,2,0,0,73,159,50,127,243,243,57,143,255,207,255,249,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_AUTO",
			command: [139,0,5,241,2,164,1,203,35,48,17,253,2,19,6,235,2,22,78,246,2,0,0,73,159,146,127,243,243,57,143,255,207,255,230,97],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_LOW",
			command: [139,0,5,239,2,172,1,223,35,44,17,255,2,20,6,242,2,34,78,244,2,0,0,73,147,255,255,63,51,152,255,252,255,254,73,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,173,1,202,35,40,17,5,3,6,6,249,2,9,78,230,2,0,0,73,147,207,255,207,204,230,63,255,63,255,242,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,168,1,3,3,4,6,216,35,41,17,241,2,24,78,229,2,0,0,43,95,127,253,251,118,63,255,127,255,116,32],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,168,1,209,35,42,17,1,3,12,6,237,2,24,78,232,2,0,0,73,147,201,255,243,243,57,143,255,207,255,243,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_LOW",
			command: [139,0,5,229,2,182,1,191,35,48,17,247,2,34,6,251,2,29,78,234,2,0,0,73,147,243,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_LOW",
			command: [139,0,5,240,2,170,1,226,35,47,17,0,3,17,6,240,2,29,78,231,2,0,0,73,147,204,255,243,243,57,143,255,207,255,249,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_LOW",
			command: [139,0,5,239,2,167,1,0,3,21,6,239,35,39,17,232,2,21,78,229,2,0,0,43,95,95,254,253,187,31,255,191,255,181,8],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_LOW",
			command: [139,0,5,241,2,169,1,197,35,47,17,253,2,7,6,229,2,26,78,232,2,0,0,73,147,201,63,252,252,206,99,255,243,255,252,146,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_LOW",
			command: [139,0,5,236,2,171,1,195,35,45,17,255,2,29,6,246,2,18,78,229,2,0,0,73,147,249,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_LOW",
			command: [139,0,5,236,2,177,1,188,35,45,17,3,3,23,6,242,2,31,78,253,2,0,0,73,147,206,127,243,243,57,143,255,207,255,254,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_LOW",
			command: [139,0,5,238,2,170,1,196,35,51,17,255,2,5,6,248,2,21,78,250,2,0,0,73,147,230,127,243,243,57,143,255,207,255,231,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_LOW",
			command: [139,0,5,234,2,175,1,192,35,61,17,242,2,29,6,247,2,29,78,245,2,0,0,73,147,201,159,252,252,206,99,255,243,255,252,225],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_LOW",
			command: [139,0,5,234,2,173,1,215,35,54,17,245,2,25,6,236,2,29,78,243,2,0,0,73,147,242,127,243,243,57,143,255,207,255,228,225],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_LOW",
			command: [139,0,5,242,2,165,1,207,35,43,17,4,3,10,6,235,2,15,78,247,2,0,0,73,147,204,159,252,252,206,99,255,243,255,254,97],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_LOW",
			command: [139,0,5,229,2,184,1,215,35,54,17,245,2,35,6,254,2,18,78,244,2,0,0,73,147,228,159,252,252,206,99,255,243,255,249,152,64],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_MID",
			command: [139,0,5,236,2,179,1,191,35,44,17,1,3,21,6,239,2,27,78,243,2,0,0,73,153,255,255,63,51,152,255,252,255,254,73,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_MID",
			command: [139,0,5,238,2,174,1,218,35,42,17,2,3,29,6,244,2,23,78,229,2,0,0,73,153,207,255,207,204,230,63,255,63,255,242,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_MID",
			command: [139,0,5,240,2,168,1,200,35,35,17,8,3,12,6,244,2,20,78,231,2,0,0,73,153,231,255,207,204,230,63,255,63,255,156,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_MID",
			command: [139,0,5,231,2,181,1,190,35,51,17,247,2,25,6,236,2,27,78,232,2,0,0,73,153,201,255,243,243,57,143,255,207,255,243,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_MID",
			command: [139,0,5,239,2,172,1,229,35,47,17,255,2,14,6,234,2,22,78,231,2,0,0,73,153,243,255,207,204,230,63,255,63,255,147,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_MID",
			command: [139,0,5,236,2,172,1,190,35,47,17,3,3,13,6,249,2,28,78,229,2,0,0,73,153,204,255,243,243,57,143,255,207,255,249,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_MID",
			command: [139,0,5,233,2,178,1,194,35,46,17,252,2,30,6,240,2,31,78,228,2,0,0,73,153,228,255,243,243,57,143,255,207,255,230,72,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_MID",
			command: [139,0,5,240,2,171,1,203,35,16,17,23,3,20,6,229,2,25,78,228,2,0,0,73,153,201,63,252,252,206,99,255,243,255,252,146,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_MID",
			command: [139,0,5,228,2,185,1,188,35,51,17,243,2,38,6,239,2,22,78,229,2,0,0,73,153,249,255,207,204,230,63,255,63,255,146,72,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_MID",
			command: [139,0,5,238,2,171,1,231,35,51,17,251,2,26,6,241,2,20,78,254,2,0,0,73,153,206,127,243,243,57,143,255,207,255,254,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_MID",
			command: [139,0,5,240,2,167,1,196,35,37,17,7,3,6,6,232,2,23,78,247,2,0,0,73,153,230,127,243,243,57,143,255,207,255,231,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_MID",
			command: [139,0,5,238,2,169,1,254,2,13,6,222,35,51,17,231,2,18,78,250,2,0,0,43,110,183,255,126,221,143,255,223,255,238,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_MID",
			command: [139,0,5,234,2,175,1,197,35,49,17,254,2,27,6,242,2,21,78,248,2,0,0,73,153,242,127,243,243,57,143,255,207,255,228,225],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_MID",
			command: [139,0,5,230,2,185,1,189,35,50,17,250,2,28,6,242,2,31,78,247,2,0,0,73,153,204,159,252,252,206,99,255,243,255,254,97],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_MID",
			command: [139,0,5,228,2,184,1,246,2,31,6,185,35,50,17,242,2,23,78,246,2,0,0,43,111,87,255,126,221,143,255,223,255,219],
		},
		//////////////////////////////////////////////////////////////
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_16",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,245,2,162,1,211,35,23,17,11,3,7,6,252,2,13,78,246,2,0,0,73,146,127,255,207,204,230,63,255,63,255,146,97],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_17",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,245,2,163,1,212,35,30,17,10,3,2,6,251,2,15,78,238,2,0,0,73,146,115,255,243,243,57,143,255,207,255,252,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_18",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,232,2,157,1,214,35,57,17,246,2,20,6,245,2,19,78,241,2,0,0,73,146,121,255,243,243,57,143,255,207,255,231,33],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_19",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,165,1,214,35,46,17,252,2,11,6,245,2,28,78,232,2,0,0,73,146,114,127,252,252,206,99,255,243,255,252,200,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_20",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,227,2,183,1,188,35,56,17,243,2,34,6,246,2,16,78,239,2,0,0,73,146,124,255,243,243,57,143,255,207,255,228,200,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_21",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,234,2,161,1,216,35,43,17,255,2,17,6,239,2,22,78,230,2,0,0,73,146,115,63,252,252,206,99,255,243,255,254,72,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_22",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,237,2,173,1,252,2,27,6,225,35,43,17,243,2,19,78,229,2,0,0,43,87,175,255,126,221,143,255,223,255,218,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_23",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,229,2,183,1,240,2,38,6,189,35,56,17,241,2,10,78,230,2,0,0,43,87,87,255,191,110,199,255,239,255,245,66],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_24",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,243,2,165,1,229,35,42,17,252,2,12,6,246,2,18,78,232,2,0,0,73,146,126,127,243,243,57,143,255,207,255,228,146,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_25",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,235,2,154,1,195,35,62,17,239,2,31,6,243,2,22,78,243,2,0,0,73,146,115,159,252,252,206,99,255,243,255,255,132],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_26",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,167,1,253,2,18,6,218,35,42,17,233,2,18,78,243,2,0,0,43,87,183,255,126,221,143,255,223,255,222,16],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_27",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,243,2,162,1,210,35,38,17,3,3,11,6,253,2,9,78,2,3,0,0,73,146,114,103,255,63,51,152,255,252,255,255,56,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_28",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,240,2,166,1,205,35,40,17,254,2,9,6,242,2,18,78,249,2,0,0,73,146,124,159,252,252,206,99,255,243,255,249,56,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_29",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,229,2,182,1,187,35,58,17,245,2,39,6,247,2,31,78,254,2,0,0,73,146,115,39,255,63,51,152,255,252,255,255,152,64],
		},
		{
			mode: "AC_MODE_FAN",
			temperature: "AC_TEMP_30",
			fan: "AC_FAN_HIGH",
			command: [139,0,5,242,2,162,1,209,35,31,17,6,3,5,6,0,3,11,78,3,3,0,0,73,146,121,39,255,63,51,152,255,252,255,254,102,16],
		},
	]
}

export default SHARP_NN